<template>
  <div class="profiel">
    <figure v-if="user.avatarUrl" class="profiel--img">
      <img :src="user.avatarUrl" class="h-full w-full object-cover">
    </figure>

    <main class="px-5">
      <ul id="socials" class="flex justify-between py-5 px-8">
        <li v-for="social in socials.filter(item => item.url)" :key="social.id" class="text-secondary-lighter">
          <a :href="social.url" target="_blank">
            <template v-if="social.socialLink">
              <font-awesome-icon :icon="['fab', social.icon]" size="lg"/>
            </template>

            <template v-else>
              <font-awesome-icon :icon="['fas', 'globe']" size="lg"/>
            </template>
          </a>
        </li>
      </ul>

      <hr class="border-t-3 text-primary-lighter mb-6">

      <section class="mb-4">
        <div class="font-bold mb-4">
          Doelgroep(en):
        </div>
        <ul class="bg-primary-light">
          <li v-for="doelgroep in user.doelgroepen" :key="doelgroep.title" class="p-2 text-sm">
            {{ doelgroep.title }}
          </li>
        </ul>
      </section>

      <section class="mb-4">
        <div class="font-bold mb-4">
          Kwalificaties:
        </div>
        <ul class="bg-primary-light">
          <li v-for="kwalificatie in user.kwalificaties" :key="kwalificatie.title" class="p-2 text-sm">
            {{ kwalificatie.title }}
          </li>
        </ul>
      </section>

      <section class="mb-6">
        <div class="font-bold mb-4">
          Adres:
        </div>
        <address class="p-2 flex items-baseline not-italic bg-primary-light">
          <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="text-secondary-lighter mr-4"/>
          <div class="flex flex-col">
            <span>{{ user.straat }} {{ user.huisnummer }}{{ user.toevoeging }}</span>
            <span>{{ user.postcode }}</span>
            <span>{{ user.stad }}</span>
          </div>
        </address>
      </section>

      <hr class="border-t-3 text-primary-lighter mb-8">

      <footer>
        <nuxt-link to="/">
          <img src="~/assets/img/logo/logo.svg" class="w-full h-auto object-contain" :class="!user.praktijk ? 'pb-8' : ''" alt="Mijn Superkracht.nl">
        </nuxt-link>
        <div v-if="user.praktijk">
          <div class="font-bold mt-6">
            {{ user.praktijk.title }}
          </div>

          <address class="py-4 flex items-baseline not-italic">
            <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="text-secondary-lighter mr-4"/>
            <div class="flex flex-col">
              <span>{{ user.praktijk.adres }}</span>
              <span>{{ user.praktijk.postcode }}</span>
              <span>{{ user.praktijk.plaats }}</span>
            </div>
          </address>

          <div v-if="user.praktijk.telefoonnummer" class="pb-8 flex items-baseline not-italic">
            <font-awesome-icon :icon="['fas', 'phone']" class="text-secondary-lighter mr-4"/>
            <div class="flex flex-col">
              <a :href="`tel:${user.praktijk.telefoonnummer}`">
                {{ user.praktijk.telefoonnummer }}
              </a>
            </div>
          </div>
        </div>
      </footer>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    socials() {
      return [
        {socialLink: true, icon: 'twitter-square', url: this.profile.twitter},
        {socialLink: true, icon: 'facebook-square', url: this.profile.facebook},
        {socialLink: true, icon: 'google-plus-square', url: this.profile.google},
        {socialLink: true, icon: 'instagram-square', url: this.profile.instagram},
        {socialLink: true, icon: 'linkedin', url: this.profile.linkedin},
        {socialLink: false, icon: 'globe', url: this.profile.website},
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.profiel {
  @apply bg-white;
  width: 500px;
  @screen lg {
    width: 400px;
  }
  box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.11);

  &--img {
    height: 500px;
  }
}
</style>
